(() => {
  const highlightPattern = /\b(?:jan(?:uary)?|feb(?:ruary)?|mar(?:ch)?|apr(?:il)?|may|jun(?:e)?|jul(?:y)?|aug(?:ust)?|sep(?:t(?:ember)?)?|oct(?:ober)?|nov(?:ember)?|dec(?:ember)?)\.?\s+\d{1,2}(?:st|nd|rd|th)?(?:,\s*\d{4})?\b|\b\d+(?:\.\d+)?%/gi;

  const underlineDates = (container) => {
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
    const textNodes = [];
    let node;

    while ((node = walker.nextNode())) {
      if (node.parentElement?.closest('u, .product-shipping-date')) continue;
      if (highlightPattern.test(node.nodeValue)) textNodes.push(node);
      highlightPattern.lastIndex = 0;
    }

    textNodes.forEach((textNode) => {
      const fragment = document.createDocumentFragment();
      let lastIndex = 0;
      highlightPattern.lastIndex = 0;
      let match;

      while ((match = highlightPattern.exec(textNode.nodeValue))) {
        fragment.append(textNode.nodeValue.slice(lastIndex, match.index));
        const date = document.createElement('span');
        date.className = 'product-shipping-date';
        date.textContent = match[0];
        fragment.append(date);
        lastIndex = match.index + match[0].length;
      }

      fragment.append(textNode.nodeValue.slice(lastIndex));
      textNode.replaceWith(fragment);
    });
  };

  const init = () => document.querySelectorAll('.product-shipping-time').forEach(underlineDates);

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
